(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .directive('brandListItem', brandListItem);

    function brandListItem() {
        return {
            restrict: 'E',
            scope: {
                brand: '=',
                onAction: '&'
            },
            templateUrl: 'app/admin/brand/brand-list-item/brand-list-item.html',
            controller: BrandListItemController,
            controllerAs: '$ctrl',
            bindToController: true
        };
    }

    function BrandListItemController($uibModal, BrandService, $translate, toastr, $localStorage) {
        var $ctrl = this;

        $ctrl.isImmoContext = $localStorage.defaultStore.immoContext;

        $ctrl.openBrandManager = function(index) {
            $ctrl.brandData = $ctrl.brand;
            return $uibModal.open({
                templateUrl: "app/admin/brand/modal-brand.html",
                windowClass: 'modal-side-menu',
                size: 'md',
                controller: "ModalBrandController",
                controllerAs: "vm",
                backdrop: 'static',
                resolve: {
                    brand: function () {
                        return $ctrl.brandData;
                    },
                    onFlyerForm: function () {
                        return true;
                    },
                }
            }).result.then(function(brandData) {
                if ($ctrl.onAction) {
                    $ctrl.onAction();
                }
            });
        };

        $ctrl.removeBrand = function() {
            var brand = $ctrl.brand;
            BrandService.removeBrand(brand.id).then(function () {
                toastr.success($translate.instant(getTranslateKey($ctrl.isImmoContext, 'brand.messages.success.remove')));
                if ($ctrl.onAction) {
                    $ctrl.onAction();
                }
                $ctrl.loadingBrands = false;
            }, function () {
                toastr.warning($translate.instant(getTranslateKey($ctrl.isImmoContext, 'brand.messages.warning.withRegisteredProducts')));
                $ctrl.loadingBrands = false;
            });
        };

        $ctrl.brandActions = [
            {
                icon: "icon-ksc-pen-to-square-light",
                label: 'flyers.actions.edit',
                method: $ctrl.openBrandManager
            },
            {
                icon: "icon-ksc-trash-light",
                label: 'flyers.actions.delete',
                method: $ctrl.removeBrand
            },
        ];

    }
})();
